import {FingerprintJSPro} from '@fingerprintjs/fingerprintjs-pro-react'

export const MAX_INTERESTS_LENGTH = 50

export const LIMITED_PACKAGE_ID = 2

export const TERMS_URL = [
  'terms-of-use',
  'privacy-policy',
  'community-rules',
  'dating-safety',
  'anti-trafficking-policy',
  'crypto-pay',
  'threeDs',
  'blog'
]

export enum SettingsTabs {
  EDIT_PROFILE = 'editProfile',
  ACCOUNT = 'account',
  NOTIFICATIONS = 'notifications',
  BILLING = 'billing',
  DEACTIVATION = 'deactivation'
}

export const SettingsItemList = [
  {id: SettingsTabs.EDIT_PROFILE, label: 'Edit profile'},
  {id: SettingsTabs.ACCOUNT, label: 'Account'},
  {id: SettingsTabs.NOTIFICATIONS, label: 'Notifications'},
  {id: SettingsTabs.BILLING, label: 'Billing'},
  {id: SettingsTabs.DEACTIVATION, label: 'Deactivation'},
]

export enum TEXT_ERRORS {
  TOO_MANY_REQUESTS = 'Too many requests! Please wait and try again',
  INTERNAL_POLICIES = 'You have been blocked by internal policies'
}

export const FP_OPTIONS_DEV = {
  apiKey: 'JsiqMQt5vHIUatQeHxWp',
  endpoint: [
    'https://gochatty.asocial-team.com/H8HqnkObERaHWxxS/8KSqTcNjEG4TW3FN',
    FingerprintJSPro.defaultEndpoint
  ],
  scriptUrlPattern: [
    'https://gochatty.asocial-team.com/H8HqnkObERaHWxxS/YfMBW7XTbe1U0B2a?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
    FingerprintJSPro.defaultScriptUrlPattern
  ]
}

export const FP_OPTIONS_PROD = {
  apiKey: 'JVqpBUOeZevDAMHAjN3S',
  endpoint: [
    'https://gochatty.com/zo7wt8FcwciK6I6j/3TyDDLsaShLbYC5i',
    FingerprintJSPro.defaultEndpoint
  ],
  scriptUrlPattern: [
    'https://gochatty.com/zo7wt8FcwciK6I6j/YDskOwHAD0JiQHXQ?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
    FingerprintJSPro.defaultScriptUrlPattern
  ]
}